// @ts-ignore
import HContainer from "./src/index.vue";
export default HContainer;